
<template>
  <div>
    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>   
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>        
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn color="green darken-1" flat="flat" @click.native="confirmDelete(row_index, delete_id)">Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

   <!--  <v-dialog v-model="dialog" persistent max-width="500px">
      <v-btn color="primary" dark slot="activator" class="mb-2">New Role</v-btn> -->
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field 
                label="Role Name" 
                v-model="formSchema.role_name"
                :rules="[v => !!v || 'Role name is required !']"
                required
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field 
                label="Role Description" 
                v-model="formSchema.role_description"
                :rules="[v => !!v || 'Role description is required !']"
                required
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          

          <!-- <v-btn color="blue darken-1" flat @click.native="close">Close</v-btn>
          <v-btn color="blue darken-1" flat @click.native="validateBeforeSubmit">Save</v-btn> -->

          <v-btn color="success" @click.native="validateBeforeSubmit" :disabled="!valid">
          <v-icon>save</v-icon> {{addUpdateBtn}}
        </v-btn>
        <v-btn color="error" @click.native="reset">
          <v-icon>refresh</v-icon> Reset
        </v-btn>
        <v-btn color="blue" @click.native="close">
          <v-icon>close</v-icon> Close
        </v-btn>

        </v-card-actions>


      </v-card>
   <!--  </v-dialog> -->

   <!--  <template v-if="permissionDiv">
     <v-card-text style="position: relative">    
      <v-btn style="right:295px;" small absolute dark top right color="pink"  @click="setPermission()">Permission</v-btn> 
      <v-btn style="right:199px;"  small absolute dark top right color="green" @click="viewRow(props)"><v-icon name="visibility" />View</v-btn>
      <v-btn style="right:104px;" small absolute dark top right color="indigo" @click="editRow(props)"><v-icon>edit</v-icon></v-btn>
      <v-btn style="right:10px;" small absolute dark top right color="red" @click="deleteRow(props)"><v-icon>delete</v-icon></v-btn>

      <v-btn style="right: 10px;top: 15px;" small absolute dark top right color="pink" @click="setPermission()">Permission</v-btn>
    </v-card-text>
  </template> -->

  <v-card-title>
    <span class="headline">User Role Data</span>
    
    <v-spacer></v-spacer>
    <v-text-field
    append-icon="search"
    label="Search"
    single-line
    hide-details
    v-model="search"
    ></v-text-field>
  </v-card-title>

  <v-data-table
  v-bind:headers="headers"
  v-bind:items="items"
  v-bind:search="search"
  v-bind:pagination.sync="pagination"
  :total-items="totalItems"
  :loading="loading"
  class="elevation-1"
  >


  <template slot="items" slot-scope="props">

    <td class="text-xs-right">

     <v-checkbox
     @click.native="showPermission(props.item.id)" 
     v-model="checkbox"
     :value="props.item"
     data-vv-name="checkbox"
     type="checkbox"
     ></v-checkbox>

   </td>
   <td class="text-xs-left">{{ props.item.role_name }}</td>
   <td class="text-xs-left">{{ props.item.role_description }}</td>

   <td class="justify-left layout px-0">
    <v-btn icon small class="mx-0" title="Edit" v-if="userRole.updateButton" @click="editItem(props.index, props.item)">
      <v-icon color="teal">edit</v-icon>
    </v-btn>
    <v-btn icon small class="mx-0" title="Delete" v-if="userRole.deleteButton" @click="deleteItem(props.index, props.item.id)">
      <v-icon color="pink">delete</v-icon>
    </v-btn>
    <v-btn icon small color="pink" class="white--text mx-0" title="Permission" v-if="prmBtn == props.item.id"  @click="setPermission()">
      <v-icon>accessibility</v-icon>    
  </v-btn>
  </td>
</template>

<template slot="no-data">
  <v-btn color="primary" @click="loadData()">Reset</v-btn>
</template>
</v-data-table>

<!-- *****************Permission Modal****************** -->
<!-- <v-dialog v-model="permissionModal" persistent width="600px">             
  <Permi  v-on:emitCloseModal="closeModal"></Permi>        
</v-dialog> -->
<!-- *****************/Permission Modal****************** -->


</div>
</template>

<script>
import Permi from './setRolePermission.vue'
const commonService = require('../../services/common.service');

export default {
 components: {
  Permi
},
data: () => ({
  valid:true,
  prmBtn:'',

  dialog: false,    
  totalItems: 0,      
  loading: true,
  pagination: {
    sortBy: 'role_id',
    descending: true,
  },
  checkbox: null,
  search:'',

  headers: [      
  {
    text: '',
    align: 'left',
    sortable: false,
    value:'',
  },
  {
    text: 'Role name',
    align: 'left',
    sortable: false,
    value: 'role_name'
  },

  { text: 'Role description', value: 'role_description' },
  { text: 'Action',value:'', },
  ],
  items: [],

  item: {           
    edit: false,       
    role_description: '',             
    login_id: '',                     
  },

  delete_id:'',
  row_index:'',
  dialog2: false,
  permissionModal:false,

  SnackbarVal: {
    snackbar: false,
    color: "success",
    message: ""
  },

  selection: 'multiple',
  permissionDiv: false,
  permissionData:[],

}),

computed: {
  userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    },

  formTitle () {
    return this.formSchema.id ? 'Edit Role' : 'New Role'
  },

  addUpdateBtn() {
    return this.formSchema.id > 0 ? "Update" : "Save";
  },

  formSchema(){
    return this.$store.getters.get_SYSUSERROLE_Schema ;
  }
},

created () {
},
mounted () {
  this.loadData()
},

methods: {

  loadData: function () {
    commonService.getAllData('role').then(res => {                         
     this.items = res.data
     this.loading = false
   });
  },

  closeModal(action) {
      //console.log('--action--------- ', action)
      if ( action == 1 ){         
        this.SnackbarVal.message = 'Data saved successfully!';
        this.SnackbarVal.snackbar = true;
        this.SnackbarVal.color = "success";
        }
        this.permissionModal = false
        this.$store.commit('SYSUSERROLE_UNSET_SCHEMA') 
    },

    showPermission(id)
    {
     // console.log('-------ids---------',this.checkbox)
        //this.checkbox = true;

        if(this.checkbox != null){
          this.permissionDiv = true
          this.permissionData = this.checkbox
          this.prmBtn=id;
        }
        else{
          this.permissionDiv = false
          this.permissionData=""
          this.prmBtn='';
        }

      },

      setPermission()
      {
        //console.log('-------------- permissionData --------------',this.permissionData)
        var props = this.permissionData
        console.log('props.id',props)
        if(props.id > 0)
        {
          var root = this
          var id = props.id
          var row = props
          /*LOAD SCHEMA WITH SELECTED ROW DATA */
          this.$store.commit('SYSUSERROLE_SET_SCHEMA',row)
          this.$store.commit('SYSUSERROLEDET_UNSET_MSG');  
          //this.permissionModal=true;
          this.$router.push('/user/permission');
        }
      },

      validateBeforeSubmit(e) {
        if (this.$refs.form.validate()) {
          this.submitForm();
        }
      },

      submitForm(e) {

        var formSchema = this.formSchema
        var root = this

        this.$validator.validateAll().then((result) => {  

          if ( formSchema.id > 0 )
          {                     
            commonService.updateFormData(formSchema, 'role').then(res => {
              if(res.status == 1){                          
                this.$set(this.items, this.row_index, {...res.data});
                this.SnackbarVal.color = "success";
              }
              else
              {
                this.SnackbarVal.color = "error";
              }
              this.SnackbarVal.message = res.message;
              this.SnackbarVal.snackbar = true;

              this.close();
            });
          }
          else
          {
            commonService.insertFormData(formSchema, 'role').then(res => {
              //this.items.unshift(res.data);
              if(res.status == 1){
                this.items.unshift({...res.data});
                this.SnackbarVal.color = "success";
              }
              else
              {
                this.SnackbarVal.color = "error";
              }
              this.SnackbarVal.message = res.message;
              this.SnackbarVal.snackbar = true;
              this.close();
            });
          }
          this.$store.commit('SYSUSERROLE_UNSET_SCHEMA') 
        });

      },

      editItem (index,item) {
        this.row_index = index;
        this.$store.commit('SYSUSERROLE_SET_SCHEMA',{...item})
        this.item.edit = true
        this.dialog = true
      },

      deleteItem (index,id) {          
        this.row_index = index;
        this.delete_id = id;
        this.dialog2 = true;
      },

      confirmDelete(row_index,id){                    
        var root = this;
        //this.$store.dispatch('delete_SYSUSERROLE',{id}).then(() => {
        commonService.deleteRow(id, "role").then(res => {
          this.items.splice(row_index, 1)

          this.SnackbarVal.message = res.message;
          this.SnackbarVal.snackbar = true;
          this.SnackbarVal.color = "success";

          this.dialog2 = false

        }).catch((err) => {
          console.log(err)
        });       
      },

      close () {
        this.item.edit = false
        this.dialog = false
        this.dialog2 = false
        this.permissionModal = false
        this.$refs.form.reset();
        this.$store.commit('SYSUSERROLE_UNSET_SCHEMA')
      },


      save () {
        if (this.item.edit) {
          this.item.edit = false
        } else {
          this.items.push(this.item)
        }
        this.dialog = false
      }
    }
  };
  </script>
  <style type="text/css">

  .mt {
    margin-left:20px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/Userrole/sysUserrole_table.vue